// extracted by mini-css-extract-plugin
module.exports = {"form":"contact-form_form__7gaMl","input":"contact-form_input__7UD6L","btn":"contact-form_btn__0sISS"};